const GOAL_TYPE = {
    car: 0,
    home: 1,
    travel: 2,
    education: 3,
    others: 4,
};

export default {
    GOAL_TYPE,
};
